import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=e8a8969c&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a8969c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a8969c')) {
      api.createRecord('e8a8969c', component.options)
    } else {
      api.reload('e8a8969c', component.options)
    }
    module.hot.accept("./AppLogo.vue?vue&type=template&id=e8a8969c&scoped=true&", function () {
      api.rerender('e8a8969c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/AppLogo.vue"
export default component.exports